import { useState, Fragment, MouseEvent } from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '2px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 14,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(0.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

interface DropDownMenuProps {
    menus?: DropDownMenuItem[];
}

interface DropDownMenuItem {
    label: string;
    value: string;
    handler: (event: MouseEvent<HTMLElement>, val: string) => void;
}

export default function DropDownMenu({ menus }: DropDownMenuProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Fragment>
            <Button
                sx={{
                    background: 'white 0% 0% no-repeat padding-box',
                    boxShadow: '0px 0px 8px #00000019',
                    borderRadius: '12px',
                    justifyContent: 'start',
                    backgroundColor: 'white',
                    fontWeight: 'bold',
                    color: 'secondary.main',
                    fontSize: '14px'
                }}
                size="large"
                color="primary"
                id="drop-down-button"
                aria-controls="drop-down-menu"
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                disableElevation={true}
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
            >
                Export Data
            </Button>
            <StyledMenu
                id="drop-down-menu"
                MenuListProps={{
                    'aria-labelledby': 'drop-down-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{
                    minWidth: '150px'
                }}
            >
                {menus && menus.map(({ label, value, handler }, index) => {
                    return <MenuItem key={index} onClick={(event) => handler(event, value)} disableRipple={true} sx={{ justifyContent: 'center' }}>
                        {label}
                    </MenuItem>
                })}
            </StyledMenu>
        </Fragment>
    );
}
